import { Injectable, inject } from '@angular/core';
import { Location } from '@freelancer/location';

@Injectable({
  providedIn: 'root',
})
export class ShareServiceHelper {
  private location = inject(Location);

  addBaseHref(link: string): string {
    if (!!link && (link.startsWith('http') || link.startsWith('//'))) {
      return link;
    }
    return `${this.location.protocol}//${this.location.host}${link}`;
  }

  buildShareUrl(link: string, excludeShareTracking: boolean = false): string {
    const url = new URL(this.addBaseHref(link));

    if (!excludeShareTracking) {
      // Add this to the query params for tracking purposes
      // (ie, if this query param is present, we know the link is from the Share components)
      url.searchParams.set('sb', 't');
    }

    return url.toString();
  }
}
